import MimeTypeFilter from "../../document/mimetype/MimeTypeFilter";
import PortalDocument from "../../document/PortalDocument";
import FileTypeGroupFilter from "../../document/mimetype/FileTypeGroupFilter";
import MimeTypes from "../../document/mimetype/MimeTypes";
import FileTypeGroup from "../../document/mimetype/FileTypeGroup";
import MimeType from "../../document/mimetype/MimeType";
import FunctionHelper from "../../../shared/helper/FunctionHelper";

export default class PortalFields {
	private readonly mimeTypeFilter: MimeTypeFilter;
	private readonly fileTypeGroupFilter: FileTypeGroupFilter;
	private _fields: Array<string>;

	constructor(
		fields: Array<string>, mimeTypeFilter?: MimeTypeFilter, fileTypeGroupFilter?: FileTypeGroupFilter
	) {
		this.mimeTypeFilter = FunctionHelper.applyValue(
			mimeTypeFilter, new MimeTypeFilter([], [MimeTypes.ALL])
		);
		this.fileTypeGroupFilter = FunctionHelper.applyValue(
			fileTypeGroupFilter, new FileTypeGroupFilter([], [FileTypeGroup.ALL])
		);
		this._fields = FunctionHelper.applyValue(fields, []);
	}

	public isSupported(selection: Array<PortalDocument>) {
		let mimeTypes: Array<MimeType> = [];
		let fileTypeGroups: Array<string> = [];

		for (let selectedDocument of selection) {
			mimeTypes.push(selectedDocument.getMimeType());
			fileTypeGroups.push(selectedDocument.getFileTypeGroup());
		}

		return this.mimeTypeFilter.checkSelection(mimeTypes) && this.fileTypeGroupFilter.checkSelection(fileTypeGroups);
	}

	public contains(field: string): boolean {
		return this._fields.includes(field);
	}

	public get fields(): Array<string> {
		return this._fields;
	}

	public set fields(value: Array<string>) {
		this._fields = value;
	}
}